export default function CGV() {
  return (
    <div className="container mb-5 px-3 px-md-4" style={{ maxWidth: '800px' }}>

      <h1 className="mb-2 text-center" style={{ fontSize: 'clamp(1.3rem, 5vw, 2rem)', fontWeight: 700 }}>
        Conditions Générales de Vente
      </h1>
      <p className="text-center text-muted mb-4" style={{ fontSize: '0.85rem' }}>
        Version en vigueur — Dernière mise à jour : juin 2025
      </p>

      {/* ── Préambule ────────────────────────────────────────────────────── */}
            <div className="p-3 rounded mb-4" style={{
        background: '#fff3cd', border: '1px solid #ffc107',
        fontSize: '0.88rem', color: '#856404',
      }}>
        ⚠️ <strong>Phase de test — application gratuite</strong><br />
        SpotyPark est actuellement en phase de test (POC).
        Toutes les fonctionnalités sont gratuites et aucun
        paiement réel n'est collecté. Les mentions tarifaires
        (abonnements, commissions) sont indicatives et
        entreront en vigueur lors du lancement commercial officiel.
      </div>

      {/* <section className="mb-4 p-3 rounded" style={{ background: '#f8f9fa', border: '1px solid #dee2e6', fontSize: '0.9rem' }}>
        <p className="mb-0">
          Les présentes Conditions Générales de Vente (CGV) régissent les relations
          commerciales entre <strong>SpotyPark</strong> — [Adresse postale] — [SIRET le cas échéant]
          et tout utilisateur souscrivant un abonnement ou réalisant une transaction
          via l'application SpotyPark.<br />
          Contact : <a href="mailto:support@spotypark.fr">support@spotypark.fr</a>
        </p>
      </section> */}

      {/* ── 1. Objet ─────────────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>1. Objet</h2>
        <p>Les présentes CGV définissent les droits et obligations des parties concernant :</p>
        <ul>
          <li>La souscription d'abonnements SPOTYFLEX et SPOTYZEN.</li>
          <li>La mise en vente et la réservation de places de stationnement entre utilisateurs.</li>
          <li>Le programme de parrainage et les récompenses associées.</li>
          <li>Les conditions de paiement, d'annulation et de remboursement applicables.</li>
        </ul>
        <p>
          Toute utilisation du service implique l'acceptation sans réserve des présentes CGV,
          des <a href="/cgu">Conditions Générales d'Utilisation</a> et de la{' '}
          <a href="/confidentialite">Politique de Confidentialité</a>.
        </p>
      </section>

      {/* ── 2. Abonnements ───────────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>2. Abonnements</h2>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>2.1 Formules disponibles</h3>
        <div className="table-responsive">
          <table className="table table-bordered table-sm" style={{ fontSize: '0.88rem' }}>
            <thead className="table-light">
              <tr>
                <th>Formule</th>
                <th>Tarif TTC</th>
                <th>Engagement</th>
                <th>Renouvellement</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>SPOTYFLEX</strong> (mensuel)</td>
                <td>15 € / mois</td>
                <td>Aucun</td>
                <td>Automatique</td>
              </tr>
              <tr>
                <td><strong>SPOTYZEN</strong> (annuel)</td>
                <td>144 € / an</td>
                <td>12 mois</td>
                <td>Automatique</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>2.2 Fonctionnalités incluses</h3>
        <ul>
          <li>Mise en vente de places de stationnement et fixation libre du tarif.</li>
          <li>Réservation de places proposées par d'autres utilisateurs abonnés.</li>
          <li>Accès à la liste des demandes acheteurs (selon le plan souscrit).</li>
          <li>Accès prioritaire aux nouvelles fonctionnalités.</li>
        </ul>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>2.3 Paiement</h3>
        <ul>
          <li>Les abonnements sont réglés par paiement sécurisé via <strong>Stripe</strong> depuis l'application.</li>
          <li>L'accès aux fonctionnalités abonnées est activé immédiatement après validation du paiement.</li>
          <li>Toute période d'abonnement entamée est due dans son intégralité.</li>
          <li>En cas d'échec de paiement, SpotyPark se réserve le droit de suspendre l'accès aux fonctionnalités premium jusqu'à régularisation.</li>
        </ul>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>2.4 Résiliation</h3>
        <ul>
          <li>Vous pouvez résilier votre abonnement à tout moment depuis votre espace compte.</li>
          <li>La résiliation prend effet à l'issue de la période en cours, sans remboursement du prorata.</li>
          <li>
            Conformément à l'article L.221-18 du Code de la consommation, vous disposez d'un
            <strong> droit de rétractation de 14 jours</strong> à compter de la souscription,
            sauf si vous avez expressément demandé à bénéficier du service avant l'expiration
            de ce délai, auquel cas le droit de rétractation est exclu conformément à
            l'article L.221-28 du même code.
          </li>
        </ul>
      </section>

      {/* ── 3. Transactions entre utilisateurs ───────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>3. Transactions entre utilisateurs</h2>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>3.1 Mise en vente</h3>
        <ul>
          <li>Tout utilisateur abonné peut proposer sa place de stationnement à la cession, en fixant librement son tarif (minimum 1 €).</li>
          <li>Le vendeur s'engage à ce que la place soit réellement disponible à la date et à l'heure indiquées.</li>
          <li>La mise en vente d'une place dans une zone réservée au personnel d'une entreprise doit être signalée comme telle via l'option dédiée de l'application.</li>
        </ul>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>3.2 Commission SpotyPark</h3>
        <ul>
          <li>SpotyPark prélève une <strong>commission de 15 %</strong> sur chaque transaction réalisée entre utilisateurs.</li>
          <li>Le prix affiché à l'acheteur est le prix toutes charges comprises (TCC), incluant la commission.</li>
          <li>Le vendeur perçoit 85 % du montant de la transaction, versé selon la procédure Stripe Connect.</li>
          <li>La commission est prélevée automatiquement au moment du paiement et n'est pas remboursable.</li>
        </ul>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>3.3 Obligations du vendeur</h3>
        <ul>
          <li>Le vendeur garantit être l'occupant légitime de la place au moment de la transaction.</li>
          <li>Il s'engage à libérer la place et à rester joignable jusqu'à l'arrivée de l'acheteur.</li>
          <li>Le vendeur est plafonné à <strong>5 annulations par jour</strong>. Au-delà, son accès à la vente peut être suspendu pour 7 jours.</li>
        </ul>
      </section>

      {/* ── 4. Annulation et remboursement ───────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>4. Annulation et remboursement des réservations</h2>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>4.1 Annulation par l'acheteur</h3>
        <div className="table-responsive">
          <table className="table table-bordered table-sm" style={{ fontSize: '0.88rem' }}>
            <thead className="table-light">
              <tr>
                <th>Délai avant la réservation</th>
                <th>Remboursement</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Plus de 24h avant</td>
                <td style={{ color: '#198754', fontWeight: 600 }}>100 %</td>
              </tr>
              <tr>
                <td>Entre 12h et 24h avant</td>
                <td style={{ color: '#ffc107', fontWeight: 600 }}>50 %</td>
              </tr>
              <tr>
                <td>Moins de 12h avant</td>
                <td style={{ color: '#dc3545', fontWeight: 600 }}>0 % — aucun remboursement</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>4.2 Annulation par le vendeur</h3>
        <ul>
          <li>En cas d'annulation par le vendeur, l'acheteur est remboursé à 100 %.</li>
          <li>Le vendeur s'expose à une suspension temporaire de son accès vendeur selon les règles de l'article 3.3.</li>
        </ul>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>4.3 Place indisponible à l'arrivée</h3>
        <ul>
          <li>Si la place est déjà occupée ou inexistante à l'arrivée de l'acheteur, un remboursement intégral est accordé sur signalement motivé dans l'application.</li>
          <li>SpotyPark se réserve le droit d'analyser le litige avant de procéder au remboursement.</li>
        </ul>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>4.4 Délai de remboursement</h3>
        <p>
          Les remboursements sont traités via Stripe et apparaissent sur le moyen de paiement
          de l'acheteur sous <strong>5 à 10 jours ouvrés</strong>.
        </p>
      </section>

      {/* ── 5. Programme de parrainage ───────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>5. Programme de parrainage</h2>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>5.1 Principe</h3>
        <p>
          Tout utilisateur inscrit dispose d'un code de parrainage personnel accessible
          depuis son espace compte. Ce code peut être communiqué à des tiers lors de
          leur inscription sur SpotyPark.
        </p>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>5.2 Récompenses</h3>
        <div className="table-responsive mb-3">
          <table className="table table-bordered table-sm" style={{ fontSize: '0.88rem' }}>
            <thead className="table-light">
              <tr>
                <th>Événement déclencheur</th>
                <th className="text-center">Parrain</th>
                <th className="text-center">Filleul</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Inscription du filleul avec le code</td>
                <td className="text-center" style={{ color: '#198754', fontWeight: 700 }}>+250 points</td>
                <td className="text-center" style={{ color: '#198754', fontWeight: 700 }}>+250 points</td>
              </tr>
              <tr>
                <td>Souscription abonnement mensuel SPOTYFLEX par le filleul</td>
                <td className="text-center" style={{ color: '#0d6efd', fontWeight: 700 }}>+1 mois offert</td>
                <td className="text-center" style={{ color: '#6c757d' }}>—</td>
              </tr>
              <tr>
                <td>Souscription abonnement annuel SPOTYZEN par le filleul</td>
                <td className="text-center" style={{ color: '#D4C362', fontWeight: 700 }}>+3 mois offerts</td>
                <td className="text-center" style={{ color: '#D4C362', fontWeight: 700 }}>+1 mois offert</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>5.3 Nature des récompenses</h3>
        <ul>
          <li>
            Les <strong>points de fidélité</strong> sont crédités automatiquement sur le compte
            du bénéficiaire à la validation de l'événement déclencheur. Ils ne sont pas
            convertibles en espèces et ne constituent pas une rémunération.
          </li>
          <li>
            Les <strong>mois d'abonnement offerts</strong> sont crédités sur la période
            d'abonnement en cours du parrain et appliqués automatiquement au renouvellement.
            Ils ne sont ni remboursables ni convertibles en espèces.
          </li>
          <li>
            Les mois offerts sont <strong>cumulatifs</strong>, dans la limite de
            <strong> 12 mois offerts par année d'abonnement</strong>.
            Tout surplus au-delà de ce plafond est automatiquement mis en crédit pour
            l'année d'abonnement suivante, sous condition de renouvellement.
          </li>
          <li>
            En l'absence d'abonnement actif au moment de l'attribution, les mois offerts
            sont placés <strong>en attente</strong> et s'activeront dès la souscription
            d'un abonnement.
          </li>
        </ul>

        <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginTop: '12px' }}>5.4 Conditions et restrictions</h3>
        <ul>
          <li>Une même personne ne peut être parrainée qu'<strong>une seule fois</strong>.</li>
          <li>L'auto-parrainage (parrainer son propre compte secondaire) est strictement interdit.</li>
          <li>
            Tout abus avéré (faux comptes, manipulation du programme) entraîne l'annulation
            des récompenses accordées et peut entraîner la suspension définitive du compte.
          </li>
          <li>
            SpotyPark se réserve le droit de modifier à tout moment les conditions, le
            barème et la valeur des récompenses du programme de parrainage, sans préavis.
          </li>
          <li>
            Les récompenses ne sont <strong>pas transférables</strong> entre comptes et
            sont annulées en cas de suppression du compte.
          </li>
        </ul>
      </section>

      {/* ── 6. Points de fidélité ────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>6. Points de fidélité et récompenses</h2>
        <ul>
          <li>
            Des points de fidélité sont attribués pour certaines actions : signalements
            de places, transactions validées, parrainage, participation au programme pionniers.
          </li>
          <li>
            Les points sont cumulables et permettent d'accéder à des niveaux de statut
            progressifs (paliers définis dans l'application) donnant droit à des avantages exclusifs.
          </li>
          <li>
            Les points <strong>n'ont pas de valeur monétaire</strong>, ne sont pas
            transférables entre comptes et expirent en cas de suppression du compte.
          </li>
          <li>
            SpotyPark se réserve le droit de modifier les règles d'attribution,
            de conversion et d'expiration des points à tout moment.
          </li>
        </ul>
      </section>

      {/* ── 7. Prix et révision ──────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>7. Prix et révision tarifaire</h2>
        <ul>
          <li>
            Les prix des abonnements et le taux de commission sont ceux affichés dans
            l'application au moment de la souscription ou de la transaction.
          </li>
          <li>
            SpotyPark se réserve le droit de modifier ses tarifs à tout moment.
            Tout changement tarifaire sera notifié aux utilisateurs concernés
            <strong> au moins 30 jours avant</strong> son entrée en vigueur.
          </li>
          <li>Les modifications tarifaires n'affectent pas les abonnements en cours pour leur durée restante.</li>
          <li>
            Tous les prix sont exprimés <strong>toutes taxes comprises (TTC)</strong>
            au taux de TVA applicable en France.
          </li>
        </ul>
      </section>

      {/* ── 8. Responsabilités ───────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>8. Responsabilités</h2>
        <ul>
          <li>
            SpotyPark agit en qualité d'<strong>intermédiaire technique</strong> et n'assume
            aucune responsabilité quant à la disponibilité effective, la conformité ou
            la légalité des places proposées par les utilisateurs.
          </li>
          <li>
            Les obligations de SpotyPark sont réputées remplies dès lors que la mise en
            relation technique entre utilisateurs a été assurée et que le paiement a été
            correctement traité.
          </li>
          <li>
            SpotyPark ne peut être tenu responsable des dommages directs ou indirects
            résultant d'un litige entre utilisateurs (place inexistante, annulation tardive,
            dommages au véhicule, etc.).
          </li>
          <li>
            La responsabilité de SpotyPark est en tout état de cause limitée au montant
            de la transaction concernée.
          </li>
        </ul>
      </section>

      {/* ── 9. Litiges et médiation ──────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>9. Litiges et médiation</h2>
        <ul>
          <li>
            En cas de litige entre utilisateurs, SpotyPark peut intervenir en qualité
            de médiateur sur la base des données enregistrées (horodatage, géolocalisation,
            historique des transactions).
          </li>
          <li>
            Toute réclamation doit être adressée en premier lieu sur l'application à{' '}
            <a href="/contact">contact</a>.
            SpotyPark s'engage à répondre dans un délai de <strong>15 jours ouvrés</strong>.
          </li>
          <li>
            À défaut de résolution amiable, vous pouvez recourir gratuitement à un
            médiateur de la consommation conformément aux articles L.611-1 et suivants
            du Code de la consommation.
          </li>
          <li>
            Vous pouvez également utiliser la plateforme européenne de règlement en ligne
            des litiges :{' '}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr
            </a>
          </li>
        </ul>
      </section>

      {/* ── 10. Données personnelles ─────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>10. Données personnelles</h2>
        <p>
          Les traitements de données personnelles réalisés dans le cadre des transactions
          sont détaillés dans notre{' '}
          <a href="/confidentialite">Politique de Confidentialité</a>.
          Les données de transaction sont conservées 10 ans conformément aux obligations
          comptables et fiscales.
        </p>
      </section>

      {/* ── 11. Loi applicable ───────────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>11. Loi applicable et juridiction</h2>
        <p>
          Les présentes CGV sont régies par le <strong>droit français</strong>.
          En cas de litige non résolu par voie amiable ou de médiation, les tribunaux
          compétents du ressort de <strong>[Ville du siège social]</strong> seront
          seuls compétents, sous réserve des règles impératives applicables aux consommateurs.
        </p>
      </section>

      {/* ── 12. Dispositions diverses ────────────────────────────────────── */}
      <section className="mb-4">
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>12. Dispositions diverses</h2>
        <ul>
          <li>
            Si une clause des présentes CGV s'avérait nulle ou inapplicable,
            les autres dispositions resteraient pleinement en vigueur.
          </li>
          <li>
            Le fait pour SpotyPark de ne pas se prévaloir d'un manquement ne constitue
            pas une renonciation à s'en prévaloir ultérieurement.
          </li>
          <li>
            Les présentes CGV constituent l'intégralité de l'accord commercial entre
            l'utilisateur et SpotyPark.
          </li>
        </ul>
      </section>

      {/* ── 13. Contact ──────────────────────────────────────────────────── */}
      <section>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700 }}>13. Contact</h2>
        <p>
          Pour toute question ou réclamation relative aux présentes CGV :<br />
          <strong>SpotyPark</strong> — <a href="/contact">Nous contacter</a><br />
          <a href="https://www.spotypark.fr" target="_blank" rel="noopener noreferrer">
            www.spotypark.fr
          </a>
        </p>
      </section>

    </div>
  );
}